import React from 'react';
import { get } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { MemberAddEditAddress } from 'ui/containers/MemberAddEditAddress';
import { memberAddEditAddresspreloader as MemberAddEditAddresspreloader } from 'ui/views/widgets/memberAddEditAddress';
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberInfoSettingShippingInfo as MemberInfoSettingShippingInfo } from 'ui/views/widgets/memberInfoSettingShippingInfo';
 *
 * // render
 * <MemberInfoSettingShippingInfo propName='propValue'/>
 */
export const memberInfoSettingShippingInfoSuccess = ( props ) => {

    const { showCustomErrorView = false, description } = props;

    if( showCustomErrorView ) {
		return (
			<div className="ui-member-shipping-settings-info-default">
 				<div className='ui-member-shipping-settings-info-default__icon'>
                    <Icon name='warningBlue' width={ 50 } height={ 50 } />
                </div>

				{/* sub-title */}
                <p className='ui-member-shipping-settings-info-default__title'>
                    { description }
                </p>

		</div>
		);
	}
     
    return (
        <div className='ui-member-info-setting-shipping-info'>
            <MemberAddEditAddress
                enableSelection={ false }
                addActionClassName={ 'ui-member-info-setting-shipping-info__action' }
                defaultDescription= { get( props, 'defaultDescription', {} ) }
                changeConfirmation= { get( props, 'changeConfirmation', {} ) }
                { ...props }
            />
        </div>
        
    );
};

// set display name
memberInfoSettingShippingInfoSuccess.displayName = 'memberInfoSettingShippingInfo';

// set default props
memberInfoSettingShippingInfoSuccess.defaultProps = {};

// prop types
memberInfoSettingShippingInfoSuccess.propTypes = {};

// Preloader
export const memberInfoShippingSettingsPreloader = ( ) => {
    return (
        <div className='ui-member-info-shipping-settings-preloader'>
            <MemberAddEditAddresspreloader hideTitle={ true } />
        </div>
    );
};

// set display name
memberInfoShippingSettingsPreloader.displayName = 'memberShippingSettingsPreloader';

// set default props
memberInfoShippingSettingsPreloader.defaultProps = {};

// prop types
memberInfoShippingSettingsPreloader.propTypes = {};


export const memberInfoSettingShippingInfo = withNetworkState( memberInfoShippingSettingsPreloader, memberInfoSettingShippingInfoSuccess );
